import { Anchor } from '@/components/ui/Anchor'

/** Contact consent under a quote-request form that collects a phone number. */
export function QuoteFormConsent() {
  return (
    <p className="text-ink-500 mt-4 text-xs leading-normal">
      By submitting, you agree Cai may contact you by phone, text, or email about your insurance quotes.
      Message and data rates may apply. See our{' '}
      <Anchor href="/privacy" className="text-ink-600 hover:text-ink underline">
        Privacy Policy
      </Anchor>
      .
    </p>
  )
}
